var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入FTDD单号查询",
                                    },
                                    model: {
                                      value: _vm.queryParam.billNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "billNo", $$v)
                                      },
                                      expression: "queryParam.billNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "客户",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择客户",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.queryParam.customerTenantId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "customerTenantId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryParam.customerTenantId",
                                      },
                                    },
                                    _vm._l(_vm.partnerList, function (p) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: p.partnerTenantId,
                                          attrs: { value: p.partnerTenantId },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(p.partnerName) +
                                              "（" +
                                              _vm._s(p.partnerTenantId) +
                                              "）\n                  "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 4, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "审核状态",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择审核状态",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.queryParam.auditStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "auditStatus",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.auditStatus",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("已审核(默认)")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "0" } },
                                        [_vm._v("未审核")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "9" } },
                                        [_vm._v("审核中")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 3, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "状态",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择状态",
                                        "allow-clear": "",
                                      },
                                      model: {
                                        value: _vm.queryParam.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.status",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "0" } },
                                        [_vm._v("待校正")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("已生成订单")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "创建时间",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "show-time": "",
                                      format: "YYYY-MM-DD HH:mm:ss",
                                    },
                                    on: { change: _vm.onTimeChange },
                                    model: {
                                      value: _vm.queryTimeRange,
                                      callback: function ($$v) {
                                        _vm.queryTimeRange = $$v
                                      },
                                      expression: "queryTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 3, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新建发图单")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "auditStatus",
                        fn: function (text) {
                          return [
                            text === "0"
                              ? _c("a-tag", { attrs: { color: "red" } }, [
                                  _vm._v("未审核"),
                                ])
                              : text === "9"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("审核中"),
                                ])
                              : _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已审核"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "status",
                        fn: function (text) {
                          return [
                            text === "0"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("待校正"),
                                ])
                              : _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已生成订单"),
                                ]),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goWorkbench(record)
                                    },
                                  },
                                },
                                [_vm._v("校正工作台")]
                              ),
                              record.auditStatus === "0" && _vm.canAudit
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        title: "确定审核通过该发图单吗?",
                                      },
                                      on: {
                                        confirm: () => _vm.handleAudit(record),
                                      },
                                    },
                                    [_c("a", [_vm._v("审核")])]
                                  )
                                : _vm._e(),
                              record.auditStatus === "0" && _vm.canSubmitFlow
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: {
                                        title: "确定提交该发图单至审批流程吗?",
                                      },
                                      on: {
                                        confirm: () =>
                                          _vm.handleSubmitFlow(record),
                                      },
                                    },
                                    [_c("a", [_vm._v("提交流程")])]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1 &&
                              record.status === "0"
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      attrs: { title: "确定删除该发图单吗?" },
                                      on: {
                                        confirm: () =>
                                          _vm.handleDelete(record.id),
                                      },
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
              _c(
                "a-modal",
                {
                  staticStyle: { top: "100px" },
                  attrs: {
                    title: "新建发图单",
                    width: 600,
                    visible: _vm.addModalVisible,
                    confirmLoading: _vm.addSaving,
                    maskClosable: false,
                    cancelText: "取消",
                    okText: "保存",
                  },
                  on: {
                    ok: _vm.handleAddOk,
                    cancel: function ($event) {
                      _vm.addModalVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form",
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "客户",
                            required: "",
                          },
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder: "请选择已绑定的客户",
                                "show-search": "",
                                "filter-option": _vm.filterPartnerOption,
                              },
                              model: {
                                value: _vm.addForm.customerTenantId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "customerTenantId", $$v)
                                },
                                expression: "addForm.customerTenantId",
                              },
                            },
                            _vm._l(_vm.partnerList, function (p) {
                              return _c(
                                "a-select-option",
                                {
                                  key: p.partnerTenantId,
                                  attrs: { value: p.partnerTenantId },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(p.partnerName) +
                                      "（" +
                                      _vm._s(p.partnerTenantId) +
                                      "）\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "图片地址",
                            required: "",
                            extra:
                              "一期暂支持手填图片URL，每行一个地址（后续接入OSS上传后可直接粘贴）",
                          },
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              placeholder: "请输入图片地址，每行一个",
                              rows: 6,
                            },
                            model: {
                              value: _vm.addForm.imageUrlsText,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "imageUrlsText", $$v)
                              },
                              expression: "addForm.imageUrlsText",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            label: "备注",
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入备注" },
                            model: {
                              value: _vm.addForm.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "remark", $$v)
                              },
                              expression: "addForm.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }